export enum ContinuityType {
	ended,
	continuous,
}

export enum FeatureClauses {
	None,
	Must,
	MustNot,
}

export type FilterTypes = "feature" | "connector" | "popularity";
export type FeatureTypes =
	"anchoring"
	| "group_endplate"
	| "group_finplate"
	| "cleat"
	| "spliceplate";
export type ConnectorTypes = "bolt" | "weld";

export type SortOption = "relevancy" | "popularity";

export interface ConnFeatureFilter {
	feature: string;
	clause: FeatureClauses;
}

export interface PopularityFilters {
	MyBookmarks: FeatureClauses;
	OthersBookmarks: FeatureClauses;
}

export interface MemberFilter {
	continuityType: ContinuityType;
	pitch: number;
	direction: number;
	cssFormCode: string | null;
}

export interface MemberModel {
	id: number;
	memberFilter: MemberFilter;
}

export interface DesignItemFilter {
	members: MemberFilter[];
	featureFilters: ConnFeatureFilter[];
	popularityFilters: PopularityFilters;
}

export interface SearchQueryModel {
	searchQueryString: string;
}

export interface CDIFilterState {
	members: MemberModel[];
	searchQuery: SearchQueryModel | undefined;
}

export interface CDIFilterStateWithFeatureFilters {
	searchFilter: CDIFilterState;
	featureFilters?: ConnFeatureFilter[];
}
